"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferralMaxTransactionsPerOrganization = exports.ReferralMinAmountToProcessTransfer = exports.ReferralAmountPerTransaction = void 0;
exports.ReferralAmountPerTransaction = 25;
exports.ReferralMinAmountToProcessTransfer = 500;
const getReferralMaxTransactionsPerOrganization = (referralAmountLimit) => Math.round(referralAmountLimit / exports.ReferralAmountPerTransaction);
exports.getReferralMaxTransactionsPerOrganization = getReferralMaxTransactionsPerOrganization;
